const routes = {
  // COMMON
  HOME: "/home",
  LOGIN: "/prihlasenie",

  // COMPONENT WHICH REDIRECT USER BY URL PARAMS
  OAUTH_HANDLER: "/",

  // ZIS COMPONENTS
  DODAVATEL: "/dodavatel",
  FAKTURY: "/faktury",
  FORGOT_PASSWORD: "/zabudnuteHeslo",
  FORM_ADD_ODBERATEL: "/formular/addOdberatel",
  FORM_SETTINGS: "/formular/settings",
  FORM_ZMENA_KONTAKTNE_UDAJE: "/formular/zmenaKontaktneUdaje",
  KONTAKTNE_UDAJE: "/kontaktneUdaje",
  ODBERATEL: "/odberatel",
  ODBERATELIA: "/odberatelia",
  ODBERNE_MIESTA: "/odberneMiesta",
  REGISTRACIA: "/registracia",
  SPOTREBA: "/spotreba",
  SPRAVY: "/spravy",
  ZMLUVY: "/zmluvy",
};

export default routes;
